import { NgModule } from '@angular/core';
import { HotspotService } from './shared/hotspot.service';
import { HotspotsMapComponent } from './hotspots-map/hotspots-map.component';
import { HotspotTrackingComponent } from './hotspot-tracking.component';
import { HotspotsAlertsComponent } from './hotspots-alerts/hotspots-alerts.component';
import { HotspotTypePipe } from './shared/hotspot-type.pipe';
import { HotspotTypeIconComponent } from './shared/hotspot-type-icon/hotspot-type-icon.component';
import { HotspotListComponent } from './hotspot-list/hotspot-list.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HOTSPOT_TRACKING_ROUTES } from './hotspot-tracking.routes';
import { HotspotAlertService } from './shared/hotspot-alert.service';


@NgModule({
  imports: [
    RouterModule.forChild(HOTSPOT_TRACKING_ROUTES),
    SharedModule
  ],
  declarations: [
    HotspotTrackingComponent,
    HotspotTypeIconComponent,
    HotspotListComponent,
    HotspotsMapComponent,
    HotspotsAlertsComponent,
    HotspotTypePipe
  ],
  providers: [
    HotspotService,
    HotspotAlertService
  ]
})
export class HotspotTrackingModule {
}
